import { render, staticRenderFns } from "./clientStoreOrderList.vue?vue&type=template&id=5b4c37ff&scoped=true&"
import script from "./clientStoreOrderList.vue?vue&type=script&lang=babel&"
export * from "./clientStoreOrderList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c37ff",
  null
  
)

export default component.exports